module.exports = __webpack_public_path__ + "img/Disconnected Icon 2.459cb033.png";